export function get(id) {
  return {
    url: `/api/users/${id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function accept(id) {
  return {
    url: `/api/users/${id}/account/accept`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function reject(id, message) {
  return {
    url: `/api/users/${id}/account/reject`,
    method: 'POST',
    body: JSON.stringify({
      rejection_message: message,
    }),
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}

export function managedCompany(name) {
  return {
    url: `/api/users?managedCompany.name=${name}&order[managedCompany.name]=asc&order[courierOfCompany.name]=asc`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
